import IconFormatter from '../../../../pages/private/utils/iconFormatter';
import randomId from '../../../../logic/utils/randomId';

export default function ConfigTable(searchPropsFactory, queue) {
  return {
    columns: [
      {
        dataIndex: 'name',
        title: 'Наименование',
        ...searchPropsFactory('name', 'наименованию'),
      },
      {
        dataIndex: 'select_by_default',
        title: 'По умолчанию',
        ...searchPropsFactory('select_by_default', 'умолчанию'),
        width: 150,
        render: (_, value) => (value.select_by_default ? 'Да' : 'Нет'),
      },
      {
        dataIndex: 'connected_queues',
        title: 'Подключенные услуги',
        ...searchPropsFactory('connected_queues', 'подключенным услугам'),
        render: (_, rec) => (rec.connected_queues.map((el) => queue.map((queue2) => {
          if (queue2.id === el.q_id) return <p key={randomId()}>{queue2.fullname}</p>;
          return null;
        }))
        ),
      },
      {
        dataIndex: 'Settings',
        width: 150,
        render: () => IconFormatter({
          filter: false, write: true, params: true, subscribe: false,
        }),
      },
    ],
  };
}
